/* unplugin-vue-components disabled */import { render } from "./image.vue?vue&type=template&id=44d9304a&scoped=true"
import script from "./image.vue?vue&type=script&lang=js"
export * from "./image.vue?vue&type=script&lang=js"

import "./image.vue?vue&type=style&index=0&id=44d9304a&scoped=true&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d9304a"],['__file',"src/controls/image.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "44d9304a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('44d9304a', __exports__)) {
    api.reload('44d9304a', __exports__)
  }
  
  module.hot.accept("./image.vue?vue&type=template&id=44d9304a&scoped=true", () => {
    api.rerender('44d9304a', render)
  })

}


export default __exports__